import React from 'react';
import { EOrderTab } from '../../../../store/ducks/long-steel-orders/types';

import { Breadcrumbs } from '@gerdau/hefesto-mais-web';
import { Title } from '@gerdau/hefesto';

import { ERoutes } from '../../../../routes';
import { EPurchaseRoutes } from '../../../Purchase/purchase.routes';
import { HeaderSection, OrderUpdateContainer, Header } from './styles';
import BottomActionBar from '../../../../components/BottomActionBar';
import { UpateItemsFinished, UpdateItemsConfirm } from '../ModalsOrder';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { OrderItemUpdate } from './OrderItemUpdate';
import { SalesOrderItem } from '../../../../store/ducks/new-long-steel-orders/types';
import { updateQueryParam } from '../../../../utils/updateQueryParams';
import { useHistory } from 'react-router-dom';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import moment from 'moment';

interface CheckboxProps {
  quantity: boolean;
  desiredDate: boolean;
  other: boolean;
}

interface ValuesProps {
  quantity: string;
  desiredDate: string;
  other: string;
}

export interface StateProps {
  checkbox: CheckboxProps;
  values: ValuesProps;
  item: SalesOrderItem;
}

export const OrderUpdate = () => {
  const data =
    useSelector(
      (state: ApplicationState) =>
        state.newLongSteelOrders.updateItems.itemsAllowed
    ) ?? [];

  if (!data) {
    return null;
  }

  const history = useHistory();
  const dispatch = useDispatch();

  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );

  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const loadingState =
    customersState.loading ||
    ordersState.loading ||
    ordersState.updateItems.loading.exportOrders ||
    ordersState.updateItems.loading.downloadOrders ||
    ordersState.updateItems.loading.cancelOrders ||
    ordersState.updateItems.loading.repeatOrders ||
    ordersState.updateItems.loading.validationOrders;

  const handleClose = () => {
    dispatch(
      sendTagging({
        event: 'solicitar_alteracoes',
        click: 'cancelar',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );

    return history.push(`${ERoutes.ORDERS}/${EPurchaseRoutes.LONG_STEEL}`);
  };
  const handleContinue = () => {
    dispatch(
      sendTagging({
        event: 'solicitar_alteracoes',
        click: 'solicitar_alteracoes',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );

    return updateQueryParam('changes', 'pending');
  };

  const [updateValues, setUpdateValues] = React.useState<StateProps[]>(() =>
    data.map((item) => ({
      checkbox: {
        quantity: true,
        desiredDate: true,
        other: true
      },
      values: {
        quantity: '',
        desiredDate: '',
        other: ''
      },
      item
    }))
  );

  const getBreadcrumbs = () => {
    return [
      { name: 'Pedidos', url: ERoutes.ORDERS },
      {
        name: 'Pedidos de aços longos e planos',
        url: `${ERoutes.ORDERS}/${EPurchaseRoutes.LONG_STEEL}`
      },
      {
        name: 'Solicitar alterações',
        url: ''
      }
    ];
  };

  const withoutUpdates = updateValues.every((data) => {
    const { checkbox, values } = data;

    if (!Object.values(checkbox).some(Boolean)) {
      return true;
    }

    if (
      checkbox.quantity &&
      (!values.quantity ||
        values.quantity === '0' ||
        Number(values.quantity) === 0)
    ) {
      return true;
    }

    if (checkbox.desiredDate && !values.desiredDate) {
      return true;
    }

    if (checkbox.other && !values.other) {
      return true;
    }

    return false;
  });

  return (
    <>
      <OrderUpdateContainer>
        <Header>
          <Breadcrumbs
            breadcrumbItems={getBreadcrumbs()}
            onClick={(e) => {
              history.push(e);
            }}
          />
          <Title level={1}>Solicitar alterações</Title>
          <HeaderSection>
            <span className="subtitle">
              Solicite alterações dos produtos selecionados. As solicitações
              serão analisadas e respondidas em até 3 dias úteis.
            </span>
          </HeaderSection>
        </Header>

        {updateValues.map((value) => (
          <OrderItemUpdate
            key={value.item.id}
            updateState={setUpdateValues}
            data={value}
          />
        ))}
      </OrderUpdateContainer>
      <BottomActionBar
        previousBtn={{
          fn: handleClose,
          name: 'cancel-update-order',
          text: 'Voltar',
          disabled: loadingState
        }}
        nextBtn={{
          fn: handleContinue,
          name: 'next-step-update-order',
          text: 'Solicitar alterações',
          disabled: withoutUpdates || loadingState
        }}
      />

      <UpdateItemsConfirm data={updateValues} />

      <UpateItemsFinished />
    </>
  );
};
